<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md6 sm12 lg6 first-row>
        <material-card :key="dataLoaded">
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Merchant detail</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1' && !merchantDetails.canBeEdited"
              @click.stop="enableEditing()"
              >Edit Merchant</v-btn
            >
            <v-btn
              class="ma-2"
              color="pink"
              v-if="merchantDetails.canBeEdited"
              @click.stop="updateMerchant()"
              >Save Changes</v-btn
            >
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="merchantDetails.canBeEdited"
              @click.stop="cancelEditing()"
              >Cancel</v-btn
            >
          </v-toolbar>
          <v-form ref="merchantDetails">
            <pre>{{ statuses[0] }}</pre>
            <v-form-base
              v-bind:value.sync="merchantDetails.data"
              v-bind:schema="merchantSchema"
            />
          </v-form>
        </material-card>
      </v-flex>

      <v-flex md6 sm12 lg6 first-row>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Contacts</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1'"
              @click.stop="contactDialog = true"
              >Add contact</v-btn
            >
          </v-toolbar>
          <contact-card
            v-for="contact in orderedContacts"
            :key="contact.contact_type_id"
            :contact="contact"
            @contact-updated="updateContact"
          />
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Campaigns</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              @click.stop="addCampaignDialog()"
              v-if="loggedUser.role === '1'"
              >Add Campaign</v-btn
            >
          </v-toolbar>

          <v-data-table
            :headers="campaignTable.headers"
            :items.sync="campaignTable.data"
            :options.sync="options"
            :server-items-length="campaignTable.total"
            :loading="campaignTable.loading"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, 30, 50],
            }"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small @click="disassociateCampaignDialog(item)"
                >mdi-delete</v-icon
              >
            </template>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:item.name="{ item }">
              <a @click="goToCampaign(item)" dark>{{ item.name }}</a>
            </template>
            <template v-slot:item.date_created="{ item }">
              <td class="text-xs-right">
                {{ item.date_created | formatDate }}
              </td>
            </template>
            <template v-slot:item.date_used="{ item }">{{
              item.date_used | formatDate
            }}</template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Qrcodes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1'"
              :disabled="!canRequestQrcodes"
              @click="qrCodesDialog = true"
              >Request QRCodes</v-btn
            >
          </v-toolbar>

          <v-data-table
            :headers="qrcodeTable.headers"
            :items="qrcodeTable.data || []"
            :options.sync="qrcodesTableOptions"
            :server-items-length="qrcodeTable.total"
            :loading="qrcodeTable.loading"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, 30, 50],
            }"
            dense
          >
            <template v-slot:body.append>
              <tr>
                <td></td>
                <td><strong>Totals:</strong></td>
                <td>
                  {{ qrcodeTable.totals.total }}
                </td>
                <td>
                  {{ qrcodeTable.totals.total_available }}
                </td>
                <td>
                  {{ qrcodeTable.totals.total_scanned }}
                </td>
                <td>
                  {{ qrcodeTable.totals.total_used }}
                </td>
              </tr>
            </template>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:item.date_created="{ item }">
              <td class="text-xs-right">
                {{ item.date_created | formatDate }}
              </td>
            </template>
            <template v-slot:item.date_used="{ item }">{{
              item.date_used | formatDate
            }}</template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Leads</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-data-table
            :headers="leadsTable.headers"
            :items="leadsTable.data"
            :options.sync="leadsTableOptions"
            :server-items-length="leadsTable.total"
            :loading="leadsTable.loading"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, 30, 50],
            }"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-dialog v-model="campaignDialog" scrollable max-width="400px">
        <v-card>
          <v-card-title>Associate Campaign</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px">
            <v-radio-group v-model="campaignSelected" column>
              <v-radio
                v-for="campaign in campaignsList"
                :key="campaign.id"
                :label="campaign.name"
                :value="campaign.id"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="secondary darken-1"
              outlined
              @click="campaignDialog = false"
              >Close</v-btn
            >
            <v-btn
              color="primary darken-1"
              @click="
                associateCampaign(campaignSelected);
                campaignDialog = false;
              "
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="qrCodesDialog" scrollable max-width="400px">
        <v-card>
          <v-card-title>Request QRcode</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px">
            <v-form ref="qrcodeRequest" v-model="qrCodeRequest.valid">
              <v-select
                v-model="qrCodeRequest.qrcodeCampaign"
                :items="campaignTable.data"
                item-value="id"
                item-text="name"
                label="Campaign"
                :rules="[(field) => (v) => v || 'Campaign is required']"
              ></v-select>
              <v-text-field
                v-model="qrCodeRequest.qrcodeAmount"
                type="number"
                label="Number of QRCodes"
                :rules="[(v) => (v && v.length > 0) || 'Field is required']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="secondary darken-1"
              outlined
              @click="qrCodesDialog = false"
              >Close</v-btn
            >
            <v-btn
              color="primary darken-1"
              @click="
                requestQrcodes();
                qrCodesDialog = false;
              "
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="campaignDisassociateDialog" scrollable max-width="400px">
        <v-card>
          <v-card-title>Disassociate Npo</v-card-title>
          <v-card-text>
            Do you really want to disassociate Campaign {{ disassociatedCampaign.name }} ?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="secondary darken-1"
              outlined
              @click="campaignDisassociateDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary darken-1"
              @click="
                dissociateCampaign(disassociatedCampaign.id);
                campaignDisassociateDialog = false;
              "
              >Disassociate Campaign</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <contact-dialog
      :show="contactDialog"
      @hide-dialog="
        contactDialog = false;
        getMerchant($route.params.merchantId);
      "
      :entityType="'merchants'"
      :entityId="+this.$route.params.merchantId"
    />
  </v-container>
</template>

<script>
import apiService from '../services'
import VFormBase from 'vuetify-form-base'
import ContactCard from '@/components/common-components/ComponentContactCard'
import contactDialog from '@/components/common-components/ComponentContactDialog'
import { mapState } from 'vuex'
import moment from 'moment'

// General form rules
const formRules = {
  required: (field) => (v) => (v && v.length > 0) || `${field} is required`,
  requiredSelect: (field) => (v) => v || `${field} is required`,
  validEmail: (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
}

export default {
  components: { VFormBase, ContactCard, contactDialog },
  data () {
    return {
      // Qrcode request
      // Flag that determines if qrcodes can be requested
      canRequestQrcodes: true,
      contactDialog: false,
      campaignDisassociateDialog: false,
      disassociatedCampaign: {},

      // Clients list for select in merchant form
      clientsList: [],

      dataLoaded: false, // Used to trigger form components re-rendering

      editContact: false,
      campaignSelected: '',
      campaignDialog: false,
      qrCodesDialog: false,
      qrCodeRequest: {
        valid: true,
        qrcodeCampaign: '',
        qrcodeAmount: null
      },

      // Client main account shema and data
      merchantDetails: {
        canBeEdited: false,
        data: {}
      },

      qrcodesTableOptions: {},

      // Merchant contacts container variable
      merchantContacts: [],

      // Campaign table schema and options
      campaignTable: {
        headers: [
          {
            text: 'Campaign',
            value: 'name'
          },
          {
            text: 'Status',
            value: 'status_name'
          },
          {
            text: 'Actions',
            value: 'actions',
            searchable: false
          }
        ],
        data: [],
        total: 0,
        loading: false
      },
      campaignTableOptions: {},

      // Qrcode table schema
      qrcodeTable: {
        totals: {},
        headers: [
          {
            text: 'Campaign',
            value: 'campaign_name'
          },
          {
            text: 'Client',
            value: 'client_name'
          },
          {
            text: 'Total',
            value: 'totalQrcodes'
          },
          {
            text: 'Available',
            value: 'available'
          },
          {
            text: 'Scanned',
            value: 'scanned',
            sortable: true
          },
          {
            text: 'Used',
            value: 'used'
          },
          {
            text: 'Creation date',
            value: 'date'
          }
        ],
        data: [],
        total: 0,
        options: {},
        loading: false
      },

      // Leads table schema
      leadsTable: {
        headers: [
          {
            text: 'First name',
            value: 'first_name'
          },
          {
            text: 'Last name',
            value: 'last_name'
          },
          {
            text: 'Email',
            value: 'email'
          },
          {
            text: 'Campaign',
            value: 'campaign_name'
          },
          {
            text: 'Npo',
            value: 'npo_name'
          }
        ],
        data: [],
        total: 0,
        loading: false,
        options: {}
      },
      // Optios prop of lead table
      leadsTableOptions: {},

      options: {},
      totalMerchantsTableContent: 0,
      merchantsTableContent: [],
      loading: true,
      merchantsLoading: false,
      legalRepresentative: [],
      primaryContact: [],

      // Campaigns
      campaignsList: [],
      availableCampaignsList: []
    }
  },

  computed: {
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas', 'relations']),

    // Add Notification service and auth service for UI Role control
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },

    // ordr contacts putting legal representative on top
    orderedContacts () {
      return _.orderBy(this.merchantContacts, 'contact_type_id')
    },
    // Schema of merchant form
    merchantSchema () {
      let clientsList = this.clientsList

      // List of merchant client relationships
      let clientRelationshipList = this.relations

      return {
        client: {
          type: 'select',
          label: 'Client',
          clearable: false,
          items: clientsList,
          itemValue: 'id',
          itemText: 'name',
          rules: [(v) => !!v || 'Client is required'],
          flex: { xs: 12, sm: 6 },
          readonly: true
        },
        relation: {
          type: 'select',
          label: 'Client Relationship',
          clearable: false,
          items: clientRelationshipList,
          itemValue: 'id',
          itemText: 'relation_name',
          rules: [(v) => !!v || 'Client Relationship is required'],
          flex: { xs: 12, sm: 6 },
          readonly: this.merchantDetails.canBeEdited === false
        },
        name: {
          type: 'text',
          label: 'Name',
          flex: 6,
          rules: [formRules.required('Name')],
          readonly: this.merchantDetails.canBeEdited === false
        },
        description: {
          type: 'textarea',
          label: 'Description',
          flex: 12,
          maxlength: 1500,
          counter: 1500,
          rules: [(v) => !v || v.length < 1500 || `Max length 1500 characters`],
          readonly: this.merchantDetails.canBeEdited === false
        },
        vat_number: {
          type: 'text',
          label: 'Vat Number',
          mask: '############',
          maxlength: 11,
          flex: 12,
          counter: 11,
          rules: [
            formRules.required('Vat Number'),
            (v) => (v && v.length === 11) || `Vat Number must be 11 characters`
          ],
          readonly: this.merchantDetails.canBeEdited === false
        },
        iban: {
          type: 'text',
          label: 'Iban',
          flex: 12,
          counter: 27,
          maxlength: 27,
          rules: [
            (v) => !v || v.length === 27 || `Iban must be 27 characters`
          ]
        },
        address: {
          type: 'text',
          label: 'Address',
          flex: 12,
          rules: [formRules.required('Address')],
          readonly: this.merchantDetails.canBeEdited === false
        },
        zip_code: {
          type: 'text',
          label: 'Zip Code',
          flex: 6,
          mask: '#####',
          maxlength: 5,
          counter: 5,
          rules: [
            formRules.required('Zip Code'),
            (v) => !v || v.length === 5 || `Zip Code must be 5 characters long`
          ],
          readonly: this.merchantDetails.canBeEdited === false
        },
        city: {
          type: 'text',
          label: 'City',
          flex: 4,
          rules: [formRules.required('City')],
          readonly: this.merchantDetails.canBeEdited === false
        },
        province: {
          type: 'text',
          label: 'Province',
          flex: 2,
          rules: [formRules.required('Province')],
          readonly: this.merchantDetails.canBeEdited === false
        },
        codice_ateco: {
          type: 'text',
          label: 'Ateco Code',
          flex: 12,
          readonly: this.merchantDetails.canBeEdited === false
        },
        website: {
          type: 'text',
          label: 'Website',
          flex: 12,
          readonly: this.merchantDetails.canBeEdited === false
        },
        status: {
          type: 'select',
          label: 'Status',
          items: this.statuses.merchants,
          itemValue: 'id',
          itemText: 'status_name',
          rules: [(v) => !!v || 'Status is required'],
          flex: { xs: 12, sm: 6 },
          readonly: this.merchantDetails.canBeEdited === false
        }
      }
    }
  },
  mounted () {
    this.getMerchant(this.$route.params.merchantId)
    this.getQrcodes(this.$route.params.merchantId)
    this.getCampaigns(this.$route.params.merchantId)
    if (this.loggedUser.client && this.loggedUser.role === '3') {
      this.getOwnClient(this.loggedUser.client)
    }
    if (this.loggedUser.role === '1') {
      this.getClientsList()
      this.getAvailableCampaigns(this.$route.params.merchantId)
    }
    this.getLeads(this.$route.params.merchantId)
  },

  watch: {
    qrcodesTableOptions: {
      handler () {
        this.getQrcodes(this.$route.params.merchantId)
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get Merchant details from API
     */
    getMerchant (merchantId) {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.sortDesc = sortDesc[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage

      // GET merchant
      apiService
        .getMerchant(merchantId, filter)
        .then((response) => {
          setTimeout(() => {
            this.merchantDetails.data = response

            apiService
              .getEntityContacts('merchant', merchantId)
              .then((response) => {
                let contacts = response || []
                this.merchantContacts = contacts
              })
            this.dataLoaded = !this.dataLoaded
            this.loading = false
          }, 800)
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Error loading merchants`
          })
        })
    },

    /**
     * Get qcodes of the Merchant
     */
    getQrcodes (merchantId) {
      this.qrcodeTable.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.qrcodesTableOptions
      let filter = {}
      filter.sortBy = sortBy[0] || 'campaign_name'
      filter.sortDesc = sortDesc[0] || true
      filter.page = page
      filter.itemsPerPage = itemsPerPage
      filter.id = merchantId
      filter.type = 'merchant_id'
      filter.merchant_id = this.$route.params.merchantId

      // Get QRCodes
      apiService
        .getQrcodes(filter)
        .then((response) => {
          const data = response.data[0]

          this.qrcodeTable.data = response.data[0] || []
          this.qrcodeTable.totals = response.data[1][0] || {}

          this.qrcodeTable.data.map((i) => {
            i.date = moment(i.date, 'YYYY-MM-DD').format('DD-MM-YYYY')
            i.totalQrcodes = i.available + i.used
            return i
          })

          // If qrcodes are present usm them by type to obtain subtotals
          // Totals are displayed under the qrcodes table
          // if (this.qrcodeTable.data.length > 0) {
          //   this.qrcodeTable.totals = this.qrcodeTable.data.reduce(function (
          //     a,
          //     b
          //   ) {
          //     return {
          //       available: a.available + b.available,
          //       used: a.used + b.used,
          //       scanned: a.scanned + b.scanned,
          //       totalQrcodes: a.totalQrcodes + b.totalQrcodes
          //     }
          //   })
          // }

          this.qrcodeTable.total = response.data.length || 0
          this.qrcodeTable.loading = false
        })
        .catch((error) => {
          console.log(error)
          this.qrcodeTable.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Errore nel caricamento dei QRCode'
          })
        })
    },

    /**
     * Lists
     */
    // Get all available clients to populate clients select field during merchant update
    getClientsList () {
      apiService
        .getClientsList()
        .then((response) => {
          this.clientsList = response
          console.log('CLIENTLIST', this.clientsList)
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Cannot load Clients'
          })
        })
    },

    // Get all available clients to populate clients select field during merchant update
    getOwnClient (clientId) {
      apiService
        .getClient(clientId)
        .then((response) => {
          this.clientsList = [response.data]
          console.log('CLIENTLIST', this.clientsList)
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Cannot load Clients'
          })
        })
    },

    /**
     * Enable merchant editing
     */
    enableContactEditing () {
      console.log(this.editContact)
      // Change control variable value
      this.editContact = true
    },

    /**
     * Contacts editing
     */

    // Update contact given data and contact id
    updateContact (contact) {
      apiService
        .updateContact(contact)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Contact updated succesfully`
          })
          // Close edit menu
          this.editContact = false
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Cannot update contact'
          })
          // Close edit menu
          this.editContact = false
        })
    },

    /**
     * Edit details
     */
    enableEditing () {
      // Change control variable value
      this.merchantDetails.canBeEdited = !this.merchantDetails.canBeEdited
      // Save backup data
      this.merchantDetails.backup = this.merchantDetails.data
      this.canRequestQrcodes = false
    },

    cancelEditing () {
      // Change control variable value
      this.merchantDetails.canBeEdited = !this.merchantDetails.canBeEdited
      // Restore backup data
      this.merchantDetails.data = this.merchantDetails.backup
      // Clear backup data
      this.merchantDetails.backup = {}
      this.canRequestQrcodes = true
    },

    updateMerchant () {
      if (!this.$refs.merchantDetails.validate()) {
        this.$store.dispatch('alert/showSnackbar', {
          color: 'error',
          text: `Missing required fields in form`
        })
        return
      }
      // Merge data from client and merchant
      const data = this.merchantDetails.data
      if (data.description === null) {
        data.description = ''
      }
      data.id = this.$route.params.merchantId
      // Aggiorna client con client_id
      apiService
        .updateMerchant(data)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Merchant updated succesfully'
          })
          // Close edit menu
          this.merchantDetails.canBeEdited = !this.merchantDetails.canBeEdited
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot update merchant ${error.message}`
          })
          // Close edit menu
          this.merchantDetails.canBeEdited = false
          this.canRequestQrcodes = true
        })
    },

    // Get all campaigns for Merchant
    getCampaigns (merchantId) {
      apiService
        .getCampaigns({ merchant: merchantId })
        .then((response) => {
          this.campaignTable.data = response
          this.campaignTable.total = response.length
          this.dataLoaded = !this.dataLoaded
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error loading campaigns'
          })
        })
    },

    getAvailableCampaigns (merchantId) {
      apiService
        .getMerchantAvailableCampaigns(merchantId)
        .then((response) => {
          this.campaignsList = response
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error loading campaigns'
          })
        })
    },

    addCampaignDialog () {
      this.campaignDialog = true
    },

    // Associate current merchant to campaign
    associateCampaign (campaignId) {
      apiService
        .associateCampaignToEntity(
          campaignId,
          'merchant',
          this.$route.params.merchantId
        )
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Campaign associated succesfully`
          })

          this.getCampaigns(this.$route.params.merchantId)
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error during campaign association'
          })
        })
    },

    /**
     *  Open disassociation dialog
     */
    disassociateCampaignDialog (campaign) {
      this.disassociatedCampaign = campaign
      this.campaignDisassociateDialog = true
    },

    dissociateCampaign (campaignId) {
      apiService
        .disassociateMerchantCampaign(campaignId, this.$route.params.merchantId)
        .then((response) => {
          // /campaigns/{campaign_id}/dissociate/merchant/{merchant_id}
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Campaign disassociated succesfully`
          })
          this.getCampaigns(this.$route.params.merchantId)
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error during campaign disassociation'
          })
        })
    },

    /* ####################################################
    #                           Leads                     #
    #################################################### */

    /*
     * Get leads generated for the merchant
     */
    getLeads (merchantId) {
      const { sortBy, sortDesc, page, itemsPerPage } = this.leadsTableOptions
      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.sortDesc = sortDesc[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage
      filter.merchant_id = merchantId

      apiService
        // Get entities leads from BE given the filter
        .fetchData('leads', filter)
        .then((response) => {
          if (response === null) {
            response = []
          }
          this.leadsTable.data = response.results

          // Assign row numbers for pagination
          this.leadsTable.total = response.total || 0
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Error loading merchant leads`
          })
        })
    },

    /**
     * Request QRCode for merchant
     */
    requestQrcodes () {
      let data = {}

      // Check if form is valid else do nothing, error messages on interface will be andled by form component
      if (this.$refs.qrcodeRequest.validate()) {
        data.campaign_id = this.qrCodeRequest.qrcodeCampaign
        data.merchant_id = parseInt(this.$route.params.merchantId)
        data.number_of_qrcode = parseInt(this.qrCodeRequest.qrcodeAmount)

        apiService
          .requestQrcodes(data)
          .then((response) => {
            // Dispatch a notification if the request is valid, qrcodes will be generated asyncronusly
            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              text: `QRCodes requested succesfully`
            })

            // Reload data and let Vue andle the data update
            this.getMerchant(this.$route.params.merchantId)
            this.getQrcodes(this.$route.params.merchantId)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `Error requesting QRCodes.`
            })
          })
      }
    },

    /* ################################################################
     #                         Navigatiom                            #
     ############################################################### */

    /**
     * Navigation to campaign detail page given id passed in props
     * This is accessigble from campaigns page
     */
    goToCampaign (item) {
      let campaignId = item.id
      this.$router.push({ name: 'campaigndetail', params: { campaignId } })
    }
  }
}
</script>
